module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/bg-208d12dcbf335da52292698631be58da.jpeg";